import React from 'react';
import ClientLayout from '../../layout/client-layout/layout';

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainClientLayout({ children }: MainLayoutProps) {
  return <ClientLayout>{children}</ClientLayout>;
}
